export const translation_0_8_A = {
  en: {},
  ko: {
    v1: {
      네: "네",
      아니요: "아니요",
      동의해요: "동의해요",
      "동의하지 못해요": "동의하지 못해요",
      typography_0_0_0:
        "이즈음에서 우리 프로그램의 범위를 한번 점검해볼 필요가 있을 것 같아요.",
      typography_1_0_0: "나의 지난 이야기",
      typography_2_0_0:
        "자해∙자살을 생각해보았던 적이 있을까요? 있다면 언제, 어떻게 하다 그런 생각을 하게 되었나요?",
      typography_3_0_0:
        "자해∙자살을 계획해보기도 하였나요? 있다면 언제 어떤 식으로 계획하였나요?",
      typography_4_0_0:
        "자해∙자살을 시도해본 적이 있을까요? 있다면 언제, 어떤 식으로 시도하였나요?",
      typography_5_0_0: "현재 정신과 진료를 받고 있나요?",
      typography_6_0_0:
        "언제부터 정신과 치료를 시작했고, 어느 주기로 진료를 받고 있나요?",
      typography_7_0_0:
        "지금 만나고 있는 의사 선생님은 위에 말씀주신 자해∙자살에 대한 내용을 알고 있나요?",
      typography_8_0_0: "진료를 받고 있지 않는 이유가 있나요?",
      typography_9_0_0: "범위와 속도",
      typography_10_0_0:
        "알려주셔서 감사해요. 프로그램을 효과적으로 진행하기 위해 꼭 짚고 넘어가야 할 부분이 있어요.",
      typography_11_0_0:
        "첫째, 자해∙자살 사고는 반드시 정신과에 내원하셔서 담당 주치의 선생님과 상의하셔야 한답니다. 이 부분은 디지털 프로그램뿐만 아니라 일반 상담에서도 동일합니다. 자해∙자살 사고는 디스턴싱으로 해결하기에는 무리가 있기 때문이에요.",
      typography_12_0_0:
        "둘째, 자해∙자살 충동이 강하게 들 때에는 디스턴싱 활동을 멈추고 반드시 담당 주치의 선생님에게 연락을 주셔야 해요.",
      typography_13_0_0:
        "셋째, 자해∙자살 사고가 동반되어 문제가 깊고 복합적인 경우에는 프로그램의 속도를 보다 천천히 진행할 수도 있답니다. 인지치료 프로그램은 내면의 괴로움들을 마주하며 하나씩 수용하고 변화를 만들어가는 과정이라, 너무 급히 진행하면 오히려 부작용이 있을 수 있기 때문이에요. 그리고 그 과정에서 코치 선생님께서 디지털 프로그램으로 다루기에는 무리가 있다고 여겨지는 부분에 대해서는 솔직하게 말씀드리고 상의드릴 수도 있을 거예요.",
      typography_14_0_0:
        "위의 세 내용에 모두 동의해주셔야 프로그램 진행을 계속 도와드릴 수 있답니다.",
    },
  },
};
